import { AlertTriangle, RefreshCw, Search } from 'lucide-react';

interface PropertySearchErrorFallbackProps {
  onRetry?: () => void;
  compact?: boolean;
}

export function PropertySearchErrorFallback({
  onRetry,
  compact = false,
}: PropertySearchErrorFallbackProps) {
  if (compact) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-red-50 border border-red-200 rounded-lg">
        <AlertTriangle className="h-4 w-4 text-red-500 flex-shrink-0" />
        <span className="text-sm text-red-700 truncate">Search failed</span>
        {onRetry && (
          <button
            onClick={onRetry}
            className="ml-auto p-1 text-red-600 hover:text-red-800 focus:outline-none"
            title="Retry search"
          >
            <RefreshCw className="h-3 w-3" />
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
      <div className="text-center">
        <div className="relative mb-3">
          <Search className="h-8 w-8 text-red-300 mx-auto" />
          <AlertTriangle className="h-4 w-4 text-red-500 absolute -top-1 -right-1 bg-red-50 rounded-full" />
        </div>
        <h3 className="text-sm font-medium text-red-900 mb-1">
          Property Search Error
        </h3>
        <p className="text-xs text-red-700 mb-3">
          Unable to load property search. Please try again.
        </p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-red-700 bg-white border border-red-300 rounded hover:bg-red-50 focus:outline-none focus:ring-1 focus:ring-red-500"
          >
            <RefreshCw className="h-3 w-3" />
            Retry
          </button>
        )}
      </div>
    </div>
  );
}
